import React from 'react'
import { navigate } from 'gatsby-link'
import theme from './../styles/theme'
import Container from '../components/Container'
import styled from 'styled-components'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

export default function Contact({data}) {
  const [state, setState] = React.useState({})

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...state,
      }),
    })
      .then(() => navigate(form.getAttribute('action')))
      .catch(error => alert(error))
  }

  return (
    <Container>
      <ContentContainer>
        <Form
          name="contact"
          method="post"
          action="/thanks"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value={data.formName} />
          <p hidden>
            <label>
              Don’t fill this out:{' '}
              <input name="bot-field" onChange={handleChange} />
            </label>
          </p>
          <InputLabel>
            <label>
              <ContactInput
                type="text"
                name="name"
                placeholder="Name"
                onChange={handleChange}
              />
            </label>
          </InputLabel>
          <InputLabel>
            <label>
              <ContactInput
                type="email"
                name="email"
                placeholder="Email"
                onChange={handleChange}
              />
            </label>
          </InputLabel>
          <InputLabel>
            <label>
              <ContactInput
                type="text"
                name="phone"
                placeholder="Phone number"
                onChange={handleChange}
              />
            </label>
          </InputLabel>
          <InputLabel>
            <label>
              <ContactInput
                type="text"
                name="company"
                placeholder="Company name"
                onChange={handleChange}
              />
            </label>
          </InputLabel>
          <InputLabel>
            <label>
              <CommentsInput
                rows="4"
                cols="50"
                name="comments"
                placeholder="We would love to hear from you !"
                onChange={handleChange}
              />
            </label>
          </InputLabel>
          <InputLabel>
            <SubmitButton type="submit">Send</SubmitButton>
          </InputLabel>
        </Form>
      </ContentContainer>
    </Container>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 30vh;
  padding: 4rem;
  justify-content: center;
  @media (max-width: ${props => props.theme.responsive.medium}) {
    flex-direction: column;
    padding: 0;
  }
`

const ContactInput = styled.input`
  padding: 1rem;
  //height: 30px;
  width: 100%;
  padding-left: 5px;
  border: 1px solid ${theme.colors.inputBorder};
  &:focus {
    border: 1px solid ${theme.colors.secondary};
  }
  @media (max-width: ${props => props.theme.responsive.medium}) {
    padding: 10px;
  }
`

const Form = styled.form`
  width: 400px;
  @media (max-width: ${props => props.theme.responsive.medium}) {
    width: 100%;
  }
`

const SubmitButton = styled.button`
  background: ${theme.colors.secondary};
  color: ${theme.colors.bright};
  cursor: pointer;
  border: none;

  @media (max-width: ${props => props.theme.responsive.medium}) {
    width: 100%;
    padding: 10px;
  }
`

const InputLabel = styled.div`
  margin: 5px;
`
const CommentsInput = styled.textarea`
  outline: none;
  width: 100%;
  resize: vertical;
  padding: 5px;
  border: 1px solid ${theme.colors.inputBorder};
  &:focus {
    border: 1px solid ${theme.colors.secondary};
  }
`
